import {connect} from '@modifi/redux'
import {aPush} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectDirectorsAreLoading} from '../../../../data/directors'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import DirectorSummaryPage, {DirectorSummaryPageProps} from './DirectorSummaryPage'
import {SECTION_DIRECTORS} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectDirectorSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_DIRECTORS_CREATE} from '../../../../routes/constants'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>
): Pick<DirectorSummaryPageProps, 'isLoading' | 'directorSummary' | 'isReadonly'> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_DIRECTORS) ===
    FeInputFieldStatus.VERIFIED
  return {
    isLoading: selectDirectorsAreLoading(state),
    directorSummary: selectDirectorSummaryData(state),
    isReadonly: isVerified || companyIsLocked,
  }
}

const mapDispatchToProps = {
  createDirector: (): any => aPush(ROUTE_COMPANY_PROFILE_DIRECTORS_CREATE),
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(DirectorSummaryPage)
